import React from "react";
import {
	Button,
	ClassNameProps,
	Column,
	If,
	makeClassName,
	Modal,
	Row,
	StyleProps,
	TruncatedText,
} from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";
import { Student, StudentMedicalContact, StudentNameFragment } from "../../../../Utilities";
import { StudentMedicalContactFormat } from "../../../Format";
import { StudentMedicalContactStudentModal } from "../StudentModal";
import styles from "./styles.module.css";

export type CardStudentMedicalContact = Pick<
	StudentMedicalContact,
	"id" | "name" | "contactType" | "phoneNumber" | "emailAddress" | "institutionName" | "address" | "notes"
>;

export type StudentMedicalContactCardProps = {
	studentMedicalContact: CardStudentMedicalContact;
	student: Pick<Student, "id"> & StudentNameFragment;
} & Partial<ClassNameProps & StyleProps>;

export function StudentMedicalContactCard({
	studentMedicalContact,
	student,
	className,
	style,
}: StudentMedicalContactCardProps) {
	const { isModalOpen, openModal, closeModal } = Modal.useToggle();

	const studentMedicalContactWithStudent = React.useMemo(
		() => ({
			...studentMedicalContact,
			student,
		}),
		[studentMedicalContact, student],
	);

	return (
		<React.Fragment>
			<Button onClick={openModal} className={makeClassName(styles["card"], className)} style={style}>
				<Column justify="spaced-start" verticalSpacing="0.25rem" style={{ overflow: "hidden" }}>
					<span className={styles["card__label"]}>
						{StudentMedicalContactFormat.Fields.contactType(studentMedicalContact.contactType)}
					</span>
					<TruncatedText className={styles["card__name"]}>
						{StudentMedicalContactFormat.name(studentMedicalContact)}
					</TruncatedText>
					<Row
						justify="spaced-start"
						align="center"
						horizontalSpacing="0.625rem"
						className={styles["card__contact-methods"]}
					>
						<If condition={!!studentMedicalContact.phoneNumber}>
							<Icon.Phone color="var(--primary-color)" />
						</If>
						<If condition={!!studentMedicalContact.emailAddress}>
							<Icon.EnvelopeSimple color="var(--primary-color)" />
						</If>
					</Row>
				</Column>
			</Button>

			<Modal.If condition={isModalOpen}>
				<StudentMedicalContactStudentModal
					studentMedicalContact={studentMedicalContactWithStudent}
					onClose={closeModal}
				/>
			</Modal.If>
		</React.Fragment>
	);
}
